import { useState } from 'react';
import { Loader } from '@nosinovacao/fe-icons';
import { Button, Checkbox, Input, useI18n } from '@nosinovacao/nosid-mfe-common';
import { SkeletonLight } from '@/components/skeleton/skeleton.light';
import { type UsernameProps } from '../-model/props';

export function UsernameLight({
  username,
  isLoading,
  isRemoving,
  onRemove,
}: Readonly<UsernameProps>) {
  const { t } = useI18n();
  const [confirmed, setConfirmed] = useState(false);

  return (
    <div className="flex h-full flex-col gap-6">
      <span className="text-nos-neutral-700 font-text-p2" data-tid="text-username-description">
        {t('Home.ChangeContacts.Username.Description')}
      </span>

      <SkeletonLight loading={isLoading} className="h-14 w-full rounded">
        <Input
          skin="light"
          id="username-display"
          label={t('Home.ChangeContacts.Username.UsernameLabel')}
          value={username}
          readOnly
          disabled
          data-tid="input-username"
        />
      </SkeletonLight>

      <div className="mt-auto flex flex-col gap-4 pb-4">
        <div className="flex cursor-pointer items-center gap-3">
          <Checkbox
            skin="light"
            id="confirm-remove-username"
            checked={confirmed}
            onChange={() => setConfirmed((prev) => !prev)}
            data-tid="checkbox-confirm-remove-username"
          />
          <span
            className="text-nos-neutral-900 font-text-p2"
            data-tid="text-confirm-remove-username"
          >
            {t('Home.ChangeContacts.Username.CheckboxLabel')}
          </span>
        </div>
        <Button
          skin="light"
          variant="primary"
          className="w-full bg-nos-red tablet:w-fit"
          disabled={!confirmed || isRemoving}
          onClick={onRemove}
          data-tid="button-remove-username"
        >
          {isRemoving ? (
            <Loader width={20} height={20} className="animate-spin" />
          ) : (
            t('Home.ChangeContacts.Username.Submit')
          )}
        </Button>
      </div>
    </div>
  );
}
